import { useState } from "react";

import { useReducedMotion } from "./anime";

/**
 * The clock behind the bar carousel (`CaseShowcase`): one bar
 * per item, the active one fills over the section's own cycle length, and its
 * `animationend` advances the index. Picking a bar hands control to the reader for good.
 *
 * Pausing on hover is deliberately *not* state, it is `[data-carousel]:hover` in
 * `styles/ui.css`, so moving the cursor over a section doesn't re-render it. Put
 * `data-carousel` on whichever element should be the pause region, and `.bar-fill`
 * with a `--bar-ms` custom property on the filling bar.
 */
export function useBarCarousel(count: number) {
  const [i, setI] = useState(0);
  /** set once, when the reader picks a bar, the carousel never resumes on its own */
  const [manual, setManual] = useState(false);
  const reduced = useReducedMotion();

  return {
    i,
    /** false when the reader took over, motion is reduced, or there is nothing to rotate */
    running: !manual && !reduced && count > 1,
    pick: (n: number) => {
      setManual(true);
      setI(n);
    },
    next: () => setI((n) => (n + 1) % count),
  };
}
